// /player/messages-and-notifications-count answers in two shapes and the
// frontend has to read both, because which one arrives depends on a backend
// flag that flips independently of any frontend deploy.
//
// Support platform OFF: a bare number, the legacy contract, unchanged since
// before any of this existed.
// Support platform ON: an object that still carries the legacy counts and adds
// the support unread totals.
//
// This one endpoint is also the only unread poll in the app. The messenger
// deliberately does not add a second one: it rides the ten second poll that
// FullLayout has always run, and that is also how an operator's switch reaches
// an already-open session. The poll carries the master switch and a version
// stamp; the stamp changing is the signal to refetch widget-config, so the
// component switches land within one tick without the poll having to carry the
// whole config document.
//
// `serving` and `configVersion` are undefined on the legacy shape, which is
// deliberate: undefined means "this backend did not tell me", and the caller
// must leave what it already had alone rather than read it as "off".
export default function readUnreadPayload(data) {
  if (data === null || data === undefined) {
    return { legacy: 0, support: { total: 0, by_ref: {} } };
  }

  if (typeof data !== "object") {
    const legacy = Number(data);
    return {
      legacy: Number.isFinite(legacy) ? legacy : 0,
      support: { total: 0, by_ref: {} },
    };
  }

  const messages = Number(data.messages) || 0;
  const notifications = Number(data.notifications) || 0;

  // support_unread_by_ref is the richer of the two and carries its own total;
  // support_unread is the flat fallback for when only the total is sent.
  const byRefBlock = data.support_unread_by_ref;
  let total = 0;
  let byRef = {};

  if (byRefBlock && typeof byRefBlock === "object") {
    total = Number(byRefBlock.total) || 0;
    byRef = byRefBlock.by_ref && typeof byRefBlock.by_ref === "object" ? byRefBlock.by_ref : {};
  } else if (data.support_unread !== undefined) {
    total = Number(data.support_unread) || 0;
  }

  return {
    legacy: messages + notifications,
    support: { total, by_ref: byRef },
    serving:
      data.support_messenger_enabled === undefined
        ? undefined
        : !!data.support_messenger_enabled,
    configVersion:
      typeof data.support_config_version === "string" ? data.support_config_version : undefined,
  };
}
